import {RuleBuilderEvaluator} from '@farbcodegmbh/amosweb-rulebuilder'
import cloneDeep from 'lodash/cloneDeep'
import {validate as uuidValidate} from 'uuid';

export default class PriceRuleBuilderEvaluator {
    constructor(comparisonElementValues) {
        this.comparisonElementValues = comparisonElementValues
        this.ruleBuilderEvaluator = new RuleBuilderEvaluator(comparisonElementValues, false)
    }


    evaluatePriceRule(priceRule) {
        if (this.ruleBuilderEvaluator.evaluateRule(priceRule.rule)) {
            let articles = Array.isArray(priceRule.articles) ? cloneDeep(priceRule.articles) : []
            this._replaceAmountUuidWithAmountValue(articles)
            return this._removeArticlesWithAmountZero(articles)
        } else {
            return []
        }
    }

    _replaceAmountUuidWithAmountValue(articles) {
        for(let article of articles) {
            if (uuidValidate(article.amount)) {
                let amount = null
                try {
                    amount = parseInt(this.comparisonElementValues[article.amount][0])
                }catch (e) {
                    amount = null
                }
                if(!amount){
                    article.amount = 0
                }else{
                    article.amount = amount
                }
            }
        }
    }

    _removeArticlesWithAmountZero(articles) {
        return articles.filter((article) => article.amount > 0)
    }

    static priceRuleHasAnyArticles(priceRule) {
        if(!priceRule.articles){
            return false
        }
        if(!priceRule.articles?.length){
            return false
        }
       for(let article of priceRule.articles){
           if(article.unitPrice !== null) return true
       }
       return false
    }
}
